<script>
import { mapActions } from 'vuex';

export default {

  props: {
    selectedSurveyID: {
      type: Number,
      required: true,
    },
    language: {
      type: String,
      default: localStorage.getItem('lang'),
    }
  },

  data() {
    return {
      series: [],
      hoveredElement: null,

      // DOM //

      gridHeight: 0,
      gridWidth: 0,
    }
  },

  mounted() {
    this._getMaterialityMatrixData();
  },


  methods: {

    ...mapActions('results', [
      'getMaterialityMatrixData',
    ]),

    _getMaterialityMatrixData() {
      const params = {
        su2_survey_id: this.selectedSurveyID, //this.selectedSurveyID,
        company_id: parseInt(this.$user.company_id), //parseInt(localStorage.company_id),
        created_by: parseInt(this.$user.user_id), //parseInt(localStorage.user_id),
        is_deleted: false,
        is_approved: true,
        language: this.language
      };
      this.getMaterialityMatrixData(params)
        .then(res => {
          this.series = res.data;
        })
        .catch(error => {
          console.error(error);
        })

    },

    // events // 

    onHoverElement(id) {
      this.hoveredElement = id;
    },
    onMouseLeaveElement() {
      this.hoveredElement = null;
    },

    // utility functions //

    getColor(id) {
      if (id == 1) {
        return '#fa8a14';
      }
      if (id == 2) {
        return '#44a900';
      }
      if (id == 3) {
        return '#de0222';
      }
      if (id == 4) {
        return '#004578';
      }
    },
    getColorConditionally(item) {
      if (item.id == this.hoveredElement) {
        return this.getColor(item.category_id);
      } else {
        return 'black';
      }
    },
    getFontWeightConditionally(item) {
      if (item.id == this.hoveredElement) {
        return 'bold';
      } else {
        return 'normal';
      }
    },
  },
}
</script>


<template>
  <div class="flex-all-centered-col">
    <div class="title">
      {{
        this.language === 'tr' ?
          'Önceliklendirme Analizi' :
          'Materiality Analysis'
      }}
    </div>
    <div class="graph-container">
      <div class="materiality-matrix">
        <div class="bar left-bar">
          <div class="flex-all-centered-row my-div-to-rotate" ref="divToRotate">
            <div class="bar-text bar-header">
              {{
                this.language === 'tr' ?
                  'Dış Paydaşlar' :
                  'External Stakeholders'
              }}
            </div>
            <div class="bar-text bar-indicator">
              {{
                this.language === 'tr' ?
                  'Yüksek Etki' :
                  'High Impact'
              }}
            </div>
          </div>
        </div>
        <div class="bar bottom-bar">
          <div class="bar-text bar-header">
            {{
              this.language === 'tr' ?
                'İç Paydaşlar' :
                'Internal Stakeholders'
            }}
          </div>
          <div class="bar-text bar-indicator">
            {{
              this.language === 'tr' ?
                'Yüksek Önem' :
                'High Importance'
            }}
          </div>
        </div>

        <div class="graph-sectors" id="grid">
          <div class="grid">
            <div class="top">
              <div class="sector sector-1"></div>
              <div class="sector sector-2"></div>
            </div>

            <div class="bottom">
              <div class="sector sector-3"></div>
              <div class="sector sector-4"></div>
            </div>


            <div v-for="(item, index) in series" :key="index" class="data-bubble" :id="item.id"
              :style="{ bottom: `${item.data[1] * 20}%`, left: `${item.data[0] * 20}%`, backgroundColor: getColor(item.category_id) }"
              v-b-tooltip.hover.top="{ title: `${$t('su2Results.resultsPage.graph.external')}: ${item.original_data[1]} - ${$t('su2Results.resultsPage.graph.internal')}: ${item.original_data[0]}` }"
              @mouseover="onHoverElement(item.id)" @mouseleave="onMouseLeaveElement()">
              {{ index + 1 }}
            </div>

          </div>
        </div>

      </div>

      <div class="legend">
        <div class="legend-item" v-for="(item, index) in series" :key="index">
          <i class="fa-solid fa-circle" :style="{ color: getColor(item.category_id) }"></i>
          <div class="legend-text"
            :style="{ fontWeight: getFontWeightConditionally(item), color: getColorConditionally(item) }"><b>{{ index + 1
              }}</b> - {{ item.name }} </div>
        </div>
      </div>
    </div>

  </div>
</template>


<style lang="scss" scoped>
.title {
  text-align: center;
  font-size: 1.5em;
  font-weight: bold;
  color: var(--sustainfinity-navy);
}

.graph-container {
  padding: 1em;
  padding-top: 4em;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  height: 100%;
  width: 100%;
}

.materiality-matrix {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;

  flex: .55;

  height: 500px;
  width: 500px;

  min-height: 150px;
  min-width: 150px;

  &>.graph-sectors {

    padding-left: 2em;
    padding-bottom: 2em;

    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex: 1;

    height: 100%;
    width: 100%;

    &>.grid {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      align-content: center;
      flex: 1;

      height: 100%;
      width: 100%;

      background: rgba(255, 255, 255, 0.35);
      background-image: url("/images/sustainfinity-bg-img.png");
      background-size: auto 40%;
      background-position: center;
      background-repeat: no-repeat;

      &>.top {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: stretch;
        align-content: stretch;

        flex: .5;
        width: 100%;
        height: 50%;

        .sector {
          display: flex;
          flex-direction: column;
          flex: 1;
        }

      }

      &>.bottom {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: stretch;
        align-content: stretch;

        flex: .5;
        width: 100%;
        height: 50%;

        .sector {
          display: flex;
          flex-direction: column;
          flex: 1;
        }
      }

      .data-bubble {
        position: absolute;
        z-index: 2;
        border-radius: 100%;

        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        text-align: center;
        padding: .1em;

        opacity: .75;
        color: white;
        // font-weight: bold;
        font-size: .7em;

        width: 1rem;
        height: 1rem;

        border: thin solid var(--sustainfinity-navy);

        cursor: default;

        &:hover {
          scale: 1.15;
          opacity: 1;
          z-index: 99999;
        }
      }
    }
  }

  &>.bar {
    position: absolute;
    z-index: 1;
    background-color: #2d4f76;
    font-size: .85em;
    color: white;
  }

  &>.left-bar {
    left: 0;
    top: 0;
    width: 2em;
    height: 100%;

    padding-top: 1.5em;
    padding-left: .25em;

    white-space: nowrap;

    >.my-div-to-rotate {
      margin-top: 12em;
      transform: rotate(270deg);

      >.bar-header {
        padding-right: 10em;
      }
    }

  }

  &>.bottom-bar {
    right: 0;
    bottom: 0;
    width: 100%;
    height: 2em;

    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    padding-right: 1em;

    white-space: nowrap;

    &>.bar-header {
      padding-right: 50%;
      transform: translateX(165px);
    }
  }
}

.bar-indicator {
  font-size: 10px;
}

.legend {
  flex: .45;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  padding: 1em;
}

.legend-item {
  margin-left: 1em;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  text-align: left;

  // font-weight: bold;

  >.legend-text {
    font-size: .9vw;
    padding-left: .66em;
    padding-bottom: .33em;
  }
}

.sector {
  opacity: .9;
}

.sector-1 {
  background-color: #edf6fd;
}

.sector-2 {
  background-color: #edd8dd;
}

.sector-3 {
  background-color: #f0f6e7;
}

.sector-4 {
  background-color: #edf6fd;
}
</style>
